import SecuritizeIdButton from './SecuritizeIdButton';

export default SecuritizeIdButton;
